export const WHATSAPP_NUMBER = "919871423482";

export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi, I'd like a free consultation about digital marketing."
)}`;

export const CONSULTATION_EMAIL = "officialpdmarketz@gmail.com";

// Fires a custom event — App.js listens and opens the ConsultationModal
export const openConsultationMail = () => {
  window.dispatchEvent(new CustomEvent("open-consultation-modal"));
};
